import { NewEmployeeReportState } from '../interface/NewEmployeeReportInterface'
import { push } from 'connected-react-router'
import { LinkStuff } from '../interface/MyInterfaces'
import { handleReportDisplayIdChange_EmployeeReport, authenticateUserOutsideLogin } from './UserActions';
import { authHeader } from '../javascript/auth-header';
import JSZip from "jszip";
import { saveAs } from 'file-saver';
import { arrayToCsv_NewEmployeeReport, numberWithCommas, toTitleCase, isAgg, getStateNameFromAbbrev, getStateNameFromFIPSCode } from '../components/Common/Helpers';

export function downloadNewEmployeeReportData(NewEmployeeReportState: NewEmployeeReportState) {
    const barplotData = NewEmployeeReportState.EmployeeBarPlot.map(item => {
        let stateName = getStateNameFromFIPSCode(item.statecode);
        return {
            ...item,
            stateName
        }
    })

    const boxplotData = NewEmployeeReportState.EmployeeBoxPlot.map(item => {
        let stateName = getStateNameFromFIPSCode(item.statecode);
        return {
            ...item,
            stateName
        }
    })
    const companyData = NewEmployeeReportState.EmployeeCompany.map(item => {
        let stateName = getStateNameFromFIPSCode(item.statecode);
        return {
            ...item,
            stateName
        }
    })
    fetch("/IRISReportsMicroservice/api/NewEmployeeReport/readme")
        .then(res => {
            if (!res.ok) {
                throw new Error('Network failed');
            }
            return res.blob();
        })
        .then(pdfblob => {
            const zip = new JSZip();
            const locationsCsv = arrayToCsv_NewEmployeeReport({ data: NewEmployeeReportState.EmployeeLocation });
            const nationalCsv = arrayToCsv_NewEmployeeReport({ data: NewEmployeeReportState.EmployeeNationalLocation });
            const chart1Csv = arrayToCsv_NewEmployeeReport({ data: barplotData });
            const chart2Csv = arrayToCsv_NewEmployeeReport({ data: boxplotData });
            const chart3Csv = arrayToCsv_NewEmployeeReport({ data: companyData });
            zip.file('destinationsmap_states.csv', locationsCsv);
            zip.file('destinationsmap_national.csv', nationalCsv);
            zip.file('chart1.csv', chart1Csv);
            zip.file('chart2.csv', chart2Csv);
            zip.file('chart3.csv', chart3Csv);

            zip.file("readme.pdf", pdfblob);
            zip.generateAsync({ type: "blob" })
                .then(function (blob) {
                    saveAs(blob, "EmployeeReportData.zip");
                });
        })
}

export function loadReleaseDate(display_id, vintage) {
    return dispatch => {
        let url = '/IRISReportsMicroservice/api/NewEmployeeReport/get_employee_release_date/' + display_id + '/' + vintage;
        var headers = authHeader();
        fetch(url, { method: 'GET', headers: headers })
            .then(function (response) {
                return response.json();
            })
            .then(function (json) {
                dispatch({
                    type: "EMPLOYEE_RELEASE",
                    payload: json['release_date']
                })
            });
    };
}

export function loadNewEmployeeReport(display_id, vintage) {

    return dispatch => {
        let x: NewEmployeeReportState = {
            showZoomed: 0
        };
        dispatch({
            type: "EMPLOYEE_REPORT_LOADING",
            payload: x
        })
        dispatch(loadNewEmployeeCompany(display_id, vintage));
        dispatch(loadNewEmployeeBoxPlot(display_id, vintage));
        dispatch(loadNewEmployeeBarPlot(display_id, vintage));
        dispatch(loadNewEmployeeMethodology(display_id, vintage));
        dispatch(loadReleaseDate(display_id, vintage))
    }
}

export function loadNewEmployeeMethodology(display_id, vintage) {
    return dispatch => {
        const url = `/IRISReportsMicroservice/api/NewEmployeeReport/methodology/${display_id}/${vintage}`;
        const headers = authHeader();
        fetch(url, { method: 'GET', headers })
            .then(res => res.json())
            .then(data => {
                dispatch({
                    type: 'EMPLOYEE_METHODOLOGY',
                    payload: data[0]
                })

                dispatch(loadNewEmployeeProfileInfo(display_id, vintage, data[0].start_year, data[0].end_year));

            })
    }
}

export function loadNewEmployeeProfileInfo(display_id, vintage, start_year, end_year) {
    return (dispatch) => {
        let url = '/IRISReportsMicroservice/api/NewEmployeeReport/profile_info/' + display_id + '/' + vintage;

        var headers = authHeader();
        fetch(url, { method: 'GET', headers: headers })
            .then(function (response) {
                return response.json();
            })
            .then(function (json) {

                dispatch(loadNewEmployeeLocation(display_id, vintage, json[0].state_fips, json[0].university, json[0].state, start_year, end_year, json[0].employees));

                dispatch({
                    type: "EMPLOYEE_PROFILE_INFO",
                    payload: json[0]
                })
            });
    };
}



export function loadNewEmployeeSharedReport(link_id, p1, p2) {
    return dispatch => {
        let url =
            "/IRISReportsMicroservice/api/SharedLink/report_link/" + link_id + "/" + p1 + "/" + p2;
        authenticateUserOutsideLogin();

        var headers = authHeader();
        fetch(url, {
            method: 'GET',
            headers: headers
        })
            .then(function (response) {
                return response.json();
            })
            .then(function (json) {
                var link: LinkStuff = json;
                if (link.link_id == -1) {

                    dispatch({
                        type: "BAD_LINK",
                        payload: json
                    });
                    dispatch(push('/reports/bad_link'));
                } else {
                    dispatch(loadNewEmployeeReport(link.display_id, link.vintage));
                    dispatch(handleReportDisplayIdChange_EmployeeReport(
                        { value: link.display_id }));
                }
            });
    };
}

const getCorrectText = (reportDisplayId, university) => {
    let names = "";
    if (reportDisplayId == "999075")
        names = "IRIS Member Universities";
    else if (reportDisplayId == "999077")
        names = "Research Universities for Michigan";
    else if (reportDisplayId == "999076")
        names = "Texas CPUPC IRIS Members";
    else
        names = university;
    return names;
}


export function loadNewEmployeeLocation(display_id, vintage, state_code, university, state, start_year, end_year, employees) {
    return (dispatch) => {
        let url = '/IRISReportsMicroservice/api/NewEmployeeReport/location/' + display_id + '/' + vintage;
        const agg = isAgg(display_id);

        var headers = authHeader();
        fetch(url, { method: 'GET', headers: headers })
            .then(function (response) {
                return response.json();
            })
            .then(function (json) {
               // console.log(json);
                let result = [];
                json.forEach(state => {

                    const lastThree = state.fips.substring(state.fips.length - 3);

                    if (lastThree == "000") {
                        result.push({ fips: state.statecode, statename: state.statename, count: state.count });
                    }

                });
                result = result.sort((a, b) => (a.count < b.count) ? 1 : -1);

                let state_text = " loading ... ";

                let people_count = 0, instate_percent = 0;

                people_count = json.filter(x => x.fips.substring(x.fips.length - 3) == "000").map(x => { return x.count; }).reduce((accumulator, currentValue) => accumulator + currentValue);

                if (state_code > 0) {
                    let michigan_count = json.filter(x => x.statecode == state_code && x.fips.substring(x.fips.length - 3) == "000")[0].count;

                    instate_percent = Math.round((michigan_count / employees) * 100);
                }

                if (result) {
                    let onlythosewithvalues = result.filter(item => item.count >= 0);
                    //console.log(onlythosewithvalues)
                    let reduced = [...new Set(onlythosewithvalues.map(item => item.statename))];
                    //console.log(reduced)
                    if (reduced.includes("District of Columbia")) {
                        state_text = ` ${reduced.length - 1} states and the District of Columbia.`;
                    }
                    else
                        state_text = ` ${reduced.length} states.`;

                    let state_text2 = agg ? 'The education, health care and information technology sectors were among the top employers.' : `Approximately <b>${instate_percent}%</b> of these research-funded employees found employment in the state of ${getStateNameFromAbbrev(state)}.`;

                    dispatch({
                        type: "STATE_TEXT",
                        payload: `<b>${numberWithCommas(employees)}</b> employees funded by research grants at ${getCorrectText(display_id, university)} between ${start_year} and ${end_year} are now employed in<b>${state_text}</b>`
                    })
                    dispatch({
                        type: "STATE_TEXT2",
                        payload: state_text2
                    })


                }

                dispatch({
                    type: "EMPLOYEE_NATIONAL_LOCATION",
                    payload: result
                })
                dispatch({
                    type: "EMPLOYEE_LOCATION",
                    payload: json
                })
            });
    };
}

export function loadNewEmployeeCompany(display_id, vintage) {
    return (dispatch) => {
        let url = '/IRISReportsMicroservice/api/NewEmployeeReport/company/' + display_id + '/' + vintage;

        var headers = authHeader();
        fetch(url, { method: 'GET', headers: headers })
            .then(function (response) {
                return response.json();
            })
            .then(function (json) {
                let toUpperCase = []
                toUpperCase = json.map(x => { return { company_name: x.company_name, count: x.count, employee: x.employee, industry: toTitleCase(x.industry), median_salary: x.median_salary, statecode: x.statecode } });
                dispatch({
                    type: "EMPLOYEE_COMPANY",
                    payload: toUpperCase
                })
            });
    };
}

export function loadNewEmployeeBoxPlot(display_id, vintage) {
    return (dispatch) => {
        let url = '/IRISReportsMicroservice/api/NewEmployeeReport/boxplot/' + display_id + '/' + vintage;

        var headers = authHeader();
        fetch(url, { method: 'GET', headers: headers })
            .then(function (response) {
                return response.json();
            })
            .then(function (json) {
                let toUpperCase = []
                toUpperCase = json.map(x => { return { lower: x.lower, q1: x.q1, q3: x.q3, median: x.median, upper: x.upper, employee: x.employee, industry: toTitleCase(x.industry), statecode: x.statecode } });

                dispatch({
                    type: "EMPLOYEE_BOXPLOT",
                    payload: toUpperCase
                })
            });
    };
}
export function loadNewEmployeeBarPlot(display_id, vintage) {
    return (dispatch) => {
        let url = '/IRISReportsMicroservice/api/NewEmployeeReport/barplot/' + display_id + '/' + vintage;

        var headers = authHeader();
        fetch(url, { method: 'GET', headers: headers })
            .then(function (response) {
                return response.json();
            })
            .then(function (json) {
                let toUpperCase = []
                toUpperCase = json.map(x => { return { count: x.count, employee: x.employee, industry: toTitleCase(x.industry), statecode: x.statecode } });
                dispatch({
                    type: "EMPLOYEE_BARPLOT",
                    payload: toUpperCase
                })
            });
    };
}

/*
export function loadEmployeeSharedReport(link_id, p1, p2) {
    return dispatch => {
        let url =
            "/IRISReportsMicroservice/api/SharedLink/report_link/" + link_id + "/" + p1 + "/" + p2;
        authenticateUserOutsideLogin();

        var headers = authHeader();
        fetch(url, {
            method: 'GET',
            headers: headers
        })
            .then(function (response) {
                return response.json();
            })
            .then(function (json) {
                var link: LinkStuff = json;
                if (link.link_id == -1) {

                    dispatch({
                        type: "BAD_LINK",
                        payload: json
                    });
                    dispatch(push('/reports/bad_link'));
                } else {
                    dispatch(loadEmployeeReport(link.display_id, link.vintage));
                    dispatch(handleReportDisplayIdChange_EmployeeReport(
                        { value: link.display_id }));
                }
            });
    };
}
*/



/*
export function loadMatchRate(display_id, vintage, EmployeeProfileInfo) {
    return dispatch => {
        let url = '/IRISReportsMicroservice/api/EmployeeReport/match_report_data/' + display_id + '/' + vintage;
        var headers = authHeader();
        fetch(url, { method: 'GET', headers: headers })
            .then(function (response) {
                return response.json();
            })
            .then(function (json) {
                dispatch({
                    type: "EMPLOYEE_MATCH_RATE",
                    payload: json[0]
                })
                dispatch(setMatchRateBullets(json[0], EmployeeProfileInfo));
            });
    };
}
*/
